exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".birght-dark {\n  margin-top: 16px;\n  margin-right: 10px;\n}\n.birght-dark .el-switch__label.is-active {\n  color: #FFFFFF !important;\n}\n.birght-dark .el-switch__label {\n  color: #5f5f5f !important;\n}\n", ""]);

// exports
